export const scanResultDimensions = Object.freeze({
  WIDTH: 480,
  HEIGHT: 640
});

export const scanResultAspectRatio =
  scanResultDimensions.WIDTH / scanResultDimensions.HEIGHT;
